import {useState} from "react";
import {Button, Card, Row, Col, Table} from "antd";
import {getPlantTrimByBatch, getInventoryById} from "../../api/Api";
import {BatchSelectWidget} from "../inventory/BatchSelectWidget";
import {Link} from "react-router";
import {fixedToDisplayUnit} from "../../util/unitutils";
import {UnitType} from "../../api/Constants";
import {handleNoSession} from "../../util/errorUtils";
import {BasicBatchInfo} from "./BasicBatchInfo"
import {toFSDate, toFSDateTime} from "../../util/timeutils";
import {saveAs} from 'file-saver';


export const HarvestReport = ({io, roomMap}) => {
    const [batch, setBatch] = useState(undefined);
    const [trim, setTrim] = useState([]);
    const [numReports, setNumReports] = useState(0);
    const [inventory, setInventory] = useState({});

    const {refresh,
        // onRefresh,
        onApiFail} = io;

    const runReport = () => {
        if (batch === undefined) {
            return;
        }

        getPlantTrimByBatch(batch.id).then(r => {
            setNumReports(numReports+1);
            const promises = [];
            setTrim(r.map((row, index) => {
                return {
                    ...row,
                    key: index
                }
            }));

            r.forEach(row => {
                promises.push(getInventoryById(row.inventoryId));
            });

            return Promise.all(promises);
            // console.log(r);
        }).then(r => {
            // console.log(`inventory...`);
            // console.log(r);
            const nextMap = {};
            r.forEach(invLine => {
                const {id} = invLine;
                nextMap[id] = {...invLine}
            });
            setInventory(nextMap);
        }).catch(e => {
            handleNoSession(e, onApiFail);
        });
    }

    const colStyle = {
        marginTop: '5px',
        marginBottom: '5px'
    }

    const onBatchSelect = (batch) => {
        setBatch(batch);
        setTrim([]);
    }

    const cardStyle = {textAlign: 'left', margin: "5px"}
    const rowStyle = {marginTop: '5px', marginBottom: '5px'}

    const reportTitle = <Row>
        <Col span={2}>
            Batch Report
        </Col>
        <Col style={{color: 'red'}}>
            Data includes all "Plant Trim" from this Batch
        </Col>
    </Row>

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record) => {
                const {name, productId} = record;
                return <Link to={`/product/${productId}`}>{name}</Link>
            }
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (val, record) => {
                const displayQuantity = fixedToDisplayUnit(val, UnitType.Gram);
                return `${displayQuantity} ${UnitType.Label[UnitType.Gram]}`;
            }
        },
        {
            title: 'Inventory',
            dataIndex: 'inventoryId',
            key: 'inventory',
            render: (val, record) => {
                const inventoryId = val;
                if (val === null) {
                    return `No entry`
                } else {
                    return <Link to={`/inventory/${inventoryId}`}>Inventory</Link>
                }
            }
        },
        {
            title: 'Current Quantity',
            dataIndex: 'inventoryId',
            key: 'currentQuantity',
            render: (val, record) => {
                // find the inventory in the map
                const inv = inventory[val];
                if (inv !== undefined) {
                    const {quantity, unit} = inv;
                    const displayQuantity = fixedToDisplayUnit(quantity, unit);
                    return `${displayQuantity} ${UnitType.Label[unit]}`;
                } else {
                    return "N/A"
                }
            }
        }
    ];

    const handleCSV = () => {
        const now = new Date();
        const lineData = ["Name, Quantity, Current Quantity, Batch, batchId, inventoryId, productId, plantId, strainId, batchCreation, batchStartTime, batchHarvestTime, flowerRoom, harvestRoom\n"];
        const {name: batchName, id: batchId, created, startTime, harvestTime, flowerRoomId, harvestRoomId} = batch;

        const creationTime = (created) ? toFSDate(new Date(created)) : 'None';
        const batchStartTime = (startTime) ? toFSDate(new Date(startTime)) : 'None';
        const batchHarvestTime = (harvestTime) ? toFSDate(new Date(harvestTime)) : 'None';
        const flowerRoom = (flowerRoomId) ? roomMap[flowerRoomId].name : 'None';
        const harvestRoom = (harvestRoomId) ? roomMap[harvestRoomId].name : 'None';

        trim.forEach(l => {
            const {name, amount, inventoryId, productId, plantId, strainId} = l;
            const displayAmount = fixedToDisplayUnit(amount, UnitType.Gram);
            let quantity, unit, displayQuantity;
            const inv = inventory[inventoryId];
            if (inv !== undefined) {
                quantity = inv.quantity;
                unit = inv.unit;
                displayQuantity = fixedToDisplayUnit(quantity, unit);
            }

            const lineBuffer = `${name}, ${displayAmount}, ${displayQuantity}, ${batchName}, ${batchId}, ${inventoryId}, ${productId}, ${plantId}, ${strainId}, ${creationTime}, ${batchStartTime}, ${batchHarvestTime}, ${flowerRoom}, ${harvestRoom} \n`

            lineData.push(lineBuffer);
        });

        const file = new Blob(lineData, { type: 'text/plain;charset=utf-8' });

        const filename = `batch_${batchName}_${toFSDateTime(now)}.csv`
        saveAs(file, filename);
        console.log(`saved ${filename}`)
    }

    const tablePagination = {
        defaultPageSize: 100,
        showSizeChanger: true,
        pageSizeOptions: [100, 200, 300, 400]
    }

    return <div>
        <Card style={cardStyle} title={"Run Batch Report"}>
            <div style={colStyle}>
                <BatchSelectWidget selectedBatch={batch} onSelect={onBatchSelect} refresh={refresh} onApiFail={onApiFail} displayType={"inline"} />
            </div>
            <Button onClick={runReport}>Run</Button>
            <Row style={rowStyle}>
                <Button disabled={trim.length <= 0} onClick={handleCSV}>Save CSV</Button>
            </Row>
        </Card>
        {(batch !== undefined) && (trim.length > 0) &&
            <BasicBatchInfo batch={batch} roomMap={roomMap} />
        }
        {(numReports > 0) && <Card style={cardStyle} title={reportTitle}>
            <Table columns={columns} dataSource={trim} pagination={tablePagination}/>
        </Card>}
    </div>
}